import {LoaderCircle,X} from 'lucide-react';
import type {StreamRecoveryNotice as Notice} from '../stream-recovery';

export function StreamRecoveryNotice({state,onDismiss}:{state:Notice;onDismiss:()=>void}){
  const retrying=state.phase==='retrying';
  return <div className={`notice stream-recovery-notice${retrying?'':' error-notice'}`} role={retrying?'status':'alert'} aria-live="polite" aria-atomic="true" data-turn-id={state.turnId}>
    {retrying&&<LoaderCircle className="spin" size={14} aria-hidden="true"/>}
    <span>{state.message}</span>
    {!retrying&&<button type="button" className="icon-button" aria-label="关闭连接错误" onClick={onDismiss}><X size={14}/></button>}
  </div>;
}
